import AppWallconnectionsIndex from "./wallConnection.vue";
import AppWallconnectionsList from "./list/list.vue";
import AppWallconnectionsItem from "./item/item.vue";

const routes = [
  {
    path: "/wallConnection",
    component: AppWallconnectionsIndex,
    meta: {
      auth: {
        roles: "wallConnection.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "wallConnection.index",
        component: AppWallconnectionsList,
        meta: {
          auth: {
            roles: "wallConnection.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "wallConnection.create",
        component: AppWallconnectionsItem,
        meta: {
          auth: {
            roles: "wallConnection.create",
            redirect: { name: "wallConnection.index" }
          }
        }
      },
      {
        path: ":id",
        name: "wallConnection.edit",
        component: AppWallconnectionsItem,
        meta: {
          auth: {
            roles: "wallConnection.update",
            redirect: { name: "wallConnection.index" }
          }
        }
      }
    ]
  }
];

export default routes;
